import { useCallback } from 'react'
import { useAppDispatch, useAppSelector } from '../../store'
import {
  setCallActive,
  setCallMinimized,
  setFloatingPosition,
  setReconnectPending,
  setWherebyParticipants,
  setCallScope,
  type WherebyParticipant,
  type CallScope
} from '../../store/slices/wherebySlice'

export const useGlobalWhereby = () => {
  const dispatch = useAppDispatch()
  const isCallActive = useAppSelector((state) => state.whereby.isCallActive)
  const isCallMinimized = useAppSelector((state) => state.whereby.isCallMinimized)
  const floatingButtonPosition = useAppSelector((state) => state.whereby.floatingButtonPosition)
  const reconnectPending = useAppSelector((state) => state.whereby.reconnectPending)
  const participants = useAppSelector((state) => state.whereby.participants)
  const callScope = useAppSelector((state) => state.whereby.callScope)

  const startCall = useCallback(() => dispatch(setCallActive(true)), [dispatch])
  const killCall = useCallback(() => dispatch(setCallActive(false)), [dispatch])
  const minimizeCall = useCallback(() => dispatch(setCallMinimized(true)), [dispatch])
  const restoreCall = useCallback(() => dispatch(setCallMinimized(false)), [dispatch])
  const setPosition = useCallback(
    (position: { x: number; y: number }) => dispatch(setFloatingPosition(position)),
    [dispatch]
  )
  const setReconnectPendingState = useCallback((value: boolean) => dispatch(setReconnectPending(value)), [dispatch])
  const setParticipants = useCallback(
    (next: WherebyParticipant[]) => dispatch(setWherebyParticipants(next)),
    [dispatch]
  )
  const setScope = useCallback((scope: CallScope | null) => dispatch(setCallScope(scope)), [dispatch])

  return {
    isCallActive,
    isCallMinimized,
    floatingButtonPosition,
    reconnectPending,
    participants,
    callScope,
    startCall,
    killCall,
    minimizeCall,
    restoreCall,
    setPosition,
    setReconnectPending: setReconnectPendingState,
    setParticipants,
    setCallScope: setScope
  }
}
